import React from "react";
import { Users } from "lucide-react";

/**
 * "Community Submitted" pill shown on cards/details for user-submitted
 * places (`park.source === "community"`). Lives next to the category
 * chip so users can tell at a glance what's UGC vs. Google-sourced.
 *
 * Colors are pulled straight from the spec — light green bg (#E8F2EC)
 * with dark green text (#4A7C59) so the badge feels native to the
 * Pawground palette without competing with the category chip.
 */
const CommunityBadge = ({ size = "sm", className = "" }) => {
  const fontSize = size === "lg" ? "13px" : "11px";
  const pad = size === "lg" ? "4px 10px" : "2px 8px";
  return (
    <span
      data-testid="community-badge"
      className={`inline-flex items-center gap-1 font-body font-semibold rounded-full ${className}`}
      style={{
        backgroundColor: "#E8F2EC",
        color: "#4A7C59",
        fontSize,
        padding: pad,
        lineHeight: 1.3,
        letterSpacing: "0.01em",
      }}
      title="Submitted by a Pawground community member"
    >
      <Users className={size === "lg" ? "w-3.5 h-3.5" : "w-3 h-3"} strokeWidth={2.4} />
      Community Submitted
    </span>
  );
};

export default CommunityBadge;
